
import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./hooks/useAuth";
import { RateUsageProvider } from "./hooks/RateUsageContext";
import theme from "./theme";

ReactDOM.createRoot(document.getElementById("root")!).render(
    <ChakraProvider theme={theme}>
        <BrowserRouter>
            <AuthProvider>
                <RateUsageProvider>
                    <App />
                </RateUsageProvider>
            </AuthProvider>
        </BrowserRouter>
    </ChakraProvider>,
);
